import { FieldErrors, Resolver } from 'react-hook-form';

import {
  EQuantityFormatKey,
  IStoreSettingsFormValues
} from '../../StoreSettings.types';

import { MIN_DIGITS_WITHOUT_SHORTHAND } from './AbbreviationsSettingsV2.consts';

const VALIDATED_SECTION_KEYS: EQuantityFormatKey[] = [
  EQuantityFormatKey.PRODUCTS,
  EQuantityFormatKey.ROLLING_OFFER,
  EQuantityFormatKey.PROGRESS_BAR,
  EQuantityFormatKey.TRIGGERED_POPUP,
  EQuantityFormatKey.SPECIAL_OFFER,
  EQuantityFormatKey.BALANCE
];

const MAX_DIGITS_ERROR_MESSAGE =
  'Max digits without shorthand must be at least 3';

export const abbreviationsFormResolver: Resolver<IStoreSettingsFormValues> = (
  values
) => {
  const sectionErrors = VALIDATED_SECTION_KEYS.reduce<Record<string, unknown>>(
    (accumulator, key) => {
      const section = values[key];
      if (
        section &&
        section.maxDigitsWithoutShorthand > 0 &&
        section.maxDigitsWithoutShorthand < MIN_DIGITS_WITHOUT_SHORTHAND
      ) {
        accumulator[key] = {
          maxDigitsWithoutShorthand: {
            type: 'min',
            message: MAX_DIGITS_ERROR_MESSAGE
          }
        };
      }
      return accumulator;
    },
    {}
  );

  const isValid = Object.keys(sectionErrors).length === 0;

  return {
    values: isValid ? values : ({} as IStoreSettingsFormValues),
    errors: sectionErrors as FieldErrors<IStoreSettingsFormValues>
  };
};
